<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <v-app id="cheerfulgive-manu">
    <v-main>
      <v-container>
        <div class="content-div">
          <!-- 上方左右側按鈕 -->
          <div class="d-flex justify-space-between">
            <v-btn color="primary" elevation="2" outlined x-large id="logout-btn" class="text-xs-h6 text-sm-h6" :ripple="false" @click="back">
              <icon-logout class="cheerfulgive-icon rotated"/>
              {{ $t('logout') }}
            </v-btn>
          </div>
          <!-- logo <images-logo2/>-->
          <v-row justify="center" class="mt-5">
            <!-- 公司logo圖片依公司代入, 若不是則為空照片圖案 -->
              <v-img v-if="company.logoUrl"
                contain
                :max-height="207"
                :max-width="206"
                :src="company.logoUrl"
              ></v-img>
              <images-logo2 v-else/>
          </v-row>
          <v-row v-for="(item, i) in menuList" :key="i">
            <v-col v-show="menuCanShow(item)" :style="[baseStyle, item.style]" @click="routerPush(item.router)">
              <v-col>
                <img alt="icon" :src="item.imgUrl">
                <h2 class="menu-text">
                  {{ $t(item.text) }}
                </h2>
              </v-col>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Api from '../apis'
import IconLogout from '@/assets/icons/logout.vue'
import ImagesLogo2 from '@/assets/images/logo2.vue'
// import PenAlt from '@/assets/images/penAlt.vue'
// import QrCode from '@/assets/images/QrCode.vue'
// import Book from '@/assets/images/Book.vue'
export default {
  components: {
    IconLogout,
    ImagesLogo2
    // PenAlt,
    // QrCode,
    // Book
  },
  data () {
    return {
      company: {},
      baseStyle: {
        borderRadius: '10px',
        color: 'white',
        padding: '8%',
        textAlign: 'center',
        cursor: 'pointer',
        letterSpacing: '0.2em'
      },
      userRoles: [],
      menuList: [
        {
          text: 'checkoutKeyIn',
          roles: ['ROLE_DESK_KEYIN_EDITABLE', 'ROLE_DESK_KEYIN_EXPORTABLE', 'ROLE_DESK_KEYIN_READABLE'],
          style: {
            background: 'linear-gradient(97.88deg, rgb(247 136 72) 33.49%, rgb(243, 173, 85) 64.55%)'
          },
          imgUrl: require('@/assets/images/cli-pen-alt.svg'),
          router: '/checkout'
        },
        {
          text: 'todayCheckoutKeyIn',
          roles: ['ROLE_DESK_REPORT_EDITABLE', 'ROLE_DESK_REPORT_EXPORTABLE', 'ROLE_DESK_REPORT_READABLE'],
          style: {
            background: 'linear-gradient(117.13deg, rgb(62 145 60) 36.87%, rgb(105, 181, 103) 65.44%)',
            margin: '5% 0'
          },
          imgUrl: require('@/assets/images/cil-book.svg'),
          router: '/record'
        },
        {
          text: 'acScanQrCode',
          roles: ['ROLE_DESK_QRCODE_EDITABLE', 'ROLE_DESK_QRCODE_EXPORTABLE'],
          style: {
            background: 'linear-gradient(117.17deg, rgb(59 73 122) 35.57%, rgb(89, 116, 185) 66.63%)'
          },
          imgUrl: require('@/assets/images/cil-qr-code.svg'),
          router: '/activity'
        }
      ]
    }
  },
  created () {
    this.userRoles = localStorage.getItem('roles')
  },
  methods: {
    back () {
      localStorage.clear()
      this.$router.push('/')
    },
    // 載入公司, 取得公司logo圖片
    loadCompany () {
      Api.company.getInfo().then(res => {
        this.company = res.data
      }).catch(() => {
        this.back()
      })
    },
    routerPush (url) {
      this.$router.push(url)
    },
    menuCanShow (menu) {
      // console.log(menu)
      if (menu.roles === undefined) return true
      return menu.roles.find(role => {
        return this.userRoles.includes(role)
      }) !== undefined
    }
  }
}
</script>

<style lang="scss" scoped>
#cheerfulgive-manu {

  .content-div {
    margin: 5%;

    .cheerfulgive-icon {
      margin-right: 5px;
    }
  }

  .menu-text {
    font-size: 2.4em;
    display: inline;
  }

  img {
    margin-right: 10px;
    width: 2.1em;
  }
}

@media screen and (max-width:767px) {
  #cheerfulgive-manu .menu-text {
    font-size: 1.4em;
  }

  img {
    margin-right: 5px !important;
    width: 1.2em !important;
  }
}
</style>
